import { render, staticRenderFns } from "./CourseBlock.vue?vue&type=template&id=1559a66e&scoped=true&"
import script from "./CourseBlock.vue?vue&type=script&lang=js&"
export * from "./CourseBlock.vue?vue&type=script&lang=js&"
import style0 from "./CourseBlock.vue?vue&type=style&index=0&id=1559a66e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1559a66e",
  null
  
)

export default component.exports